import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import {
  MobileConsultationSections,
  UpdateMobileConsultationSections,
} from '../../domain/models/mobile-consultation-sections.model';
import {
  IMobileConsultationSectionsRepository,
} from '../../domain/repositories/mobile-consultation-sections.repository';
import {
  MobileConsultationSectionsRemoteDatasource,
} from '../datasources/remote/mobile-consultation-sections.remote-datasource';
import { MobileConsultationSectionsMapper } from '../mappers/mobile-consultation-sections.mapper';

@Injectable()
export class MobileConsultationSectionsRepositoryImpl implements IMobileConsultationSectionsRepository {
  private readonly datasource = inject(MobileConsultationSectionsRemoteDatasource);
  private readonly mapper = inject(MobileConsultationSectionsMapper);

  public get(organizationId: number): Observable<MobileConsultationSections> {
    return this.datasource.get(organizationId).pipe(
      map((dto) => this.mapper.toMobileConsultationSections(dto)),
    );
  }

  public update(
    organizationId: number,
    request: UpdateMobileConsultationSections,
  ): Observable<MobileConsultationSections> {
    return this.datasource.update(organizationId, this.mapper.toUpdateRequest(request)).pipe(
      map((dto) => this.mapper.toMobileConsultationSections(dto)),
    );
  }
}
